import { useRouteMatch, useLocation } from 'react-router-dom'
import { FOLDER_PATH, HANDBOOK_PATH } from 'paths'
import { useMemo } from 'react'

export const useHandbookRouteMatch = () => {
  const location = useLocation()
  const routeMatch = useRouteMatch<{ folderSlug: string; doc?: string }>([HANDBOOK_PATH, FOLDER_PATH])

  return useMemo(() => {
    // extract doc from handbook custom path, e.g:
    //   /foo-handbook/doc-123   =>  doc-123
    const splitPath = location.pathname.split('/')
    const docOrFolderFromCustomPath = splitPath?.[2]
    const docOrFolder = routeMatch?.params.doc || docOrFolderFromCustomPath
    const isFolderSlug = docOrFolder?.match(/folder_\w{32}$/)
    const isDocSlug = !isFolderSlug && docOrFolder?.match(/\w{32}$/)

    const handbookKey = routeMatch?.params.folderSlug.split('-').pop()
    const docKey = isDocSlug ? docOrFolder.split('-').pop() : undefined
    // DO NOT USE unless you're trying to redirect away from a legacy handbook subfolder URL
    // like /folders/:folderSlug/folder_:subfolderKey
    const folderKey = isFolderSlug ? docOrFolder.split('_').pop() : undefined

    return {
      handbookKey,
      docKey,
      folderKey,
    }
  }, [location.pathname, routeMatch?.params])
}
